import { IKeyAny } from "services/api/api-client";

// based on WebSocket's readyState - https://www.w3.org/TR/websockets/#the-websocket-interface
export const CONNECTING = 0;
export const OPEN = 1;
export const CLOSED = 3;

export type ReadyState = typeof CONNECTING | typeof OPEN | typeof CLOSED;

/**
 * Types for websocket notifications
 * wss://api.helpdesk.com/v1/notifications
 */
export type Action =
  | "auth"
  | "update"
  | "create"
  | "delete"
  | "subscribe"
  | "updateBatch"
  | "unsubscribe"
  | "notify"
  | "done"
  | "error";
type Type = "push" | "response";
type Target =
  | "accounts:subscription"
  | "accounts:billing"
  | "auth"
  | "agents"
  | "integrations"
  | "teams"
  | "licenses"
  | "sources"
  | "tickets"
  | "cannedResponses"
  | "tags"
  | "macros"
  | "blockedEmails"
  | "trustedEmails"
  | "emailDomains"
  | "replyAddresses"
  | "mailboxes"
  | "rules"
  | "rulesCounters"
  | "agentActions"
  | "contactForms"
  | "views"
  | "templates"
  | "customFields"
  | "asyncTasks";

type Payload = ISinglePayload | ISinglePayload[];

export type PaymentMethodType = "manual" | "shopify" | "partner";

export interface ISinglePayloadError {
  errorCode: string;
  message: string;
  details?: { lackingSeats?: number; paymentMethod?: PaymentMethodType; [key: string]: unknown };
}

interface ISinglePayload {
  ID: string;
  error?: ISinglePayloadError;
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

type ErrorType =
  | "validation" // message format wrong
  | "auth"
  | "syntaxError"
  | "tokenExpired"
  | "tokenRevokedMigration"
  | "channelBroken" // internal problem with RabbitMQ
  | "agentRemoved"
  | "tokenRevoked"
  | "sockError" // websocket problem
  | "authTimeout" // no auth in specified time frame
  | "aliveTimeout" // no response to ping message in specified time frame
  | "missingResource";

export interface IIncomingMessage {
  action?: Action;
  type?: Type;
  target?: Target;
  payload?: Payload;
  requestID?: string;
  errorType?: ErrorType;
  errorDetails?: string;
}

export interface IOutgoingMessage {
  action: Action;
  [key: string]: string | IKeyAny;
}
